<div class="flex flex-col gap-8">
  @if (brandIsLoading()) {
    <div class="relative min-h-[5rem]">
      <korviu-loader />
    </div>
  } @else {
    <h1 class="text-[#222528] text-[2.3125rem] font-bold text-center leading-[1.4]">{{ brandName() }}</h1>
    <workspace-breadcrumb />
    <korviu-list [config]="productListConfig" />
  }
</div>
